import { formatDateShort, relativeDateDisplayLabel } from '@ardoq/date-time';
import { type I18nLocale } from '@ardoq/i18n';
import { type Locale } from '@ardoq/locale';

export const getDateValueLabel =
  (i18nLocale: I18nLocale, locale: Locale) =>
  (value: string): string =>
    relativeDateDisplayLabel(value, i18nLocale) ||
    formatDateShort(value, locale);
